import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Upsert Contact v1 Configuration Validator
 * Validates HubSpot contact upsert configuration
 */
export const Hubspot_Upsert_Contact_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    idProperty: requiredString('Search By field is required'),
    contactId: requiredString('Contact Value is required'),
    contactProperties: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=hubspot-upsert-contact-1.js.map